import React from "react";
import { Box, CircularProgress } from "@mui/material";

const Loader = ({ open = true }) => {
  if (!open) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.5)", 
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1300,
      }}
    >
      <CircularProgress size={60} thickness={4} />
    </Box>
  );
};

export default Loader;
